import { integrationSlugs } from '@global/constants'

export const getIntegrationFormat = (integration, template) => {
  const form = formats[integration.slug] ?? formats.default
  form.name = `[${template.template.name}]`
  form.assignedEntityId = template.id
  form.integrationId = integration.id
  form.integration_id = integration.id
  form.connector_type_id = integration.powered_by_connector_type_id
  form.integrationType = integration.type
  form.slug = integration.slug

  return form
}

const formats = {
  default: {
    id: null,
    name: '',
    assigned_entity_type: 'template',
    assigned_integration_id: null,
    integration_id: null,
    connector_id: null,
    connector_type_id: null,
    metadata: { filename_pattern: '{{template_name}}{{submitted_at}}' },
    delimiter: ',',
    file_type: ['csv'],
    filename_pattern: '{{template_name}}_{{submitted_at}}',
    assignedEntityType: 'template',
    assignedEntityId: null,
    integrationType: 'OUTPUT',
    report_type: 'default',
    included_output_fields: [],
    config_hash: null,
  },
  [integrationSlugs.GOOGLE_DCM]: {
    id: null,
    name: '',
    assigned_entity_type: 'template',
    assigned_integration_id: null,
    integration_id: null,
    connector_id: null,
    connector_type_id: null,
    metadata: {
      adId: '',
      campaignId: '',
      placementId: '',
      campaign: '',
      filename_pattern: '{{template_name}}{{submitted_at}}',
    },
    mapping_fields: {
      adId: '',
      campaignId: '',
      placementId: '',
      campaign: '',
    },
    new_mapping: false,
    delimiter: ',',
    file_type: ['csv'],
    filename_pattern: '{{template_name}}{{submitted_at}}',
    assignedEntityType: 'template',
    assignedEntityId: null,
    integrationType: 'OUTPUT',
    report_type: 'default',
    included_output_fields: [],
    config_hash: null,
  },
  [integrationSlugs.FACEBOOK_ADS]: {
    name: '',
    assignedEntityType: 'template',
    assignedEntityId: null,
    id: null,
    integrationType: 'INPUT',
    url: 'https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/facebook-ads.png',
    metadata: {
      ad_id: '',
      generated_link: '',
      creative_id: '',
    },
    mapping_fields: {
      ad_id: '',
      generated_link: '',
      creative_id: '',
    },
    new_mapping: false,
    connectorId: null,
    connector_type_id: null,
    isValid: true,
    required: {
      ad_id: '',
      generated_link: '',
      creative_id: '',
    },
  },
  [integrationSlugs.ADOBE_INBOUND]: {
    name: '',
    assignedEntityType: 'template',
    assignedEntityId: null,
    id: null,
    integrationType: 'INPUT',
    // url: 'https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/facebook-ads.png',
    metadata: {
      Key: '',
    },
    connectorId: null,
    connector_type_id: null,
    isValid: true,
    required: {
      Key: '',
    },
  },
  [integrationSlugs.AWS_S3_INBOUND]: {
    assignedEntityType: 'template',
    assignedEntityId: null,
    id: null,
    integrationType: 'INPUT',
    url: 'https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/aws-s3-inbound.png',
    metadata: {
      delimiter: ',',
      filePrefix: '',
      folder: '',
    },
    connectorId: null,
  },
  [integrationSlugs.SFTP_PULL]: {
    name: '',
    assignedEntityType: 'template',
    assignedEntityId: null,
    id: null,
    integrationType: 'INPUT',
    url: 'https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/sftp-pull.png',
    connectorId: null,
    metadata: { folder: '' },
    folder: '',
  },
}
